import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { RoleContainerModel, TenantRoleContainerModel } from '../../../../../models/aggregates/role';
import { ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class TenantRoleService extends BaseApiTemplateService<TenantRoleContainerModel> {

  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/roles';
    this.httpClient = http;
  }

  getByCriteriaAsTenantAdmin(pagination: Pagination, apiVisa: ApiVisa): Observable<PagingResponseModel<RoleContainerModel>> {

    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + "/login-tenant-ep/query?" + pagination.getQueryKeyValues();
    }

    return this.httpClient.get<PagingResponseModel<RoleContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa)
    );
  }

  getByGuidAsTenantAdmin(guid: String, apiVisa: ApiVisa): Observable<BasicApiResponseModel<RoleContainerModel>> {

    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + "/login-tenant-ep/" + guid;
    }

    return this.httpClient.get<BasicApiResponseModel<RoleContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa)
    );
  }

  createRoleAsTenantAdmin(role: RoleContainerModel, apiVisa: ApiVisa): Observable<BasicApiResponseModel<RoleContainerModel>> {

    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + "/login-tenant-ep";
    }

    return this.httpClient.post<BasicApiResponseModel<RoleContainerModel>>(
      this.apiUrl,
      role,
      this.getHttpHeader(apiVisa)
    );
  }

  updateRoleAsTenantAdmin(role: RoleContainerModel, apiVisa: ApiVisa): Observable<BasicApiResponseModel<RoleContainerModel>> {

    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + "/login-tenant-ep";
    }

    return this.httpClient.put<BasicApiResponseModel<RoleContainerModel>>(
      this.apiUrl,
      role,
      this.getHttpHeader(apiVisa)
    );
  }

  deleteAsTenantAdmin(guid: String, apiVisa: ApiVisa) {

    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + "/login-tenant-ep/" + guid;
    }

    return this.httpClient.delete(
      this.apiUrl,
      this.getHttpHeader(apiVisa)
    );
  }

}


